import type { SliderWidget } from '../../../widgets';
import {
  BindingRow,
  CheckboxField,
  NumberField,
  Row,
  Section,
  TextField,
  patcher,
  rangeError,
  stepError,
  type WidgetEditorProps,
} from '../fields';

/** Schieberegler.
 *
 *  Der Filter auf Zahlenpunkte ist hier keine Bequemlichkeit: an einem
 *  Bool-Punkt haette der Regler zwei erreichbare Stellungen und hundert, die
 *  stumm verworfen werden. Das soll der Editor verhindern, bevor es
 *  passiert. */
export function SliderEditor(
  { widget, plantId, onChange }: WidgetEditorProps<SliderWidget>,
) {
  const patch = patcher(widget, onChange);
  const range = rangeError(widget.min, widget.max);
  const stepped = widget.step !== null && widget.step !== undefined;
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Befehls-Datenpunkt"
          value={widget.commandPoint}
          plantId={plantId}
          filter={{ writable: true, valueType: 'number' }}
          onChange={(next) => patch({ commandPoint: next })}
        />
        <BindingRow
          label="Rückmelde-Datenpunkt"
          value={widget.feedbackPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ feedbackPoint: next })}
        />
      </Section>
      <Section
        title="Bereich"
        hint="Geschrieben wird erst beim Loslassen, und nur wenn die Änderung über dem Totband liegt."
      >
        <Row>
          <NumberField
            label="Unten"
            value={widget.min}
            required
            error={range}
            onChange={(next) => patch({ min: next ?? 0 })}
          />
          <NumberField
            label="Oben"
            value={widget.max}
            required
            error={range ? ' ' : undefined}
            onChange={(next) => patch({ max: next ?? 0 })}
          />
        </Row>
        <Row>
          <NumberField
            label="Totband"
            value={widget.deadband}
            min={0}
            hint="In der Einheit des Punktes."
            onChange={(next) => patch({ deadband: next })}
          />
          <TextField
            label="Einheit"
            value={widget.unit}
            placeholder="%"
            onChange={(next) => patch({ unit: next })}
          />
        </Row>
        <CheckboxField
          label="Rastet auf Schritte"
          checked={stepped}
          hint="Aus heißt stufenlos zwischen unten und oben."
          onChange={(on) => patch({ step: on ? (widget.step ?? 1) : null })}
        />
        {stepped && (
          <NumberField
            label="Schrittweite"
            value={widget.step}
            min={0}
            error={stepError(widget.step)}
            onChange={(next) => patch({ step: next ?? null })}
          />
        )}
      </Section>
    </>
  );
}
